import React, { Component } from 'react';

import { Loading, SERVER_ERROR } from 'commons';
import EmailForm from './EmailForm';
import EmailList from './EmailList';
import request from '../request';

class Email extends Component {
  state = {
    displaySelectEmailList: true,
    email: '',
    signupToken: '',
    loading: true,
    error: ''
  };

  componentDidMount() {
    this.initRequest();
  }

  initRequest = async () => {
    try {
      const res = await request('/session/login', 'action=request');

      if (res.status >= 300 || res.status < 200) {
        this.setState({ loading: false, ...SERVER_ERROR });
        return;
      }

      const data = await res.json();
      this.setState({ signupToken: data.sign_up_token });
      this.props.onUpdateSession({ ...data });

      if (data.action !== 'login') return;

      if (!data.emails) {
        this.toggleSelectEmailList(false);
      }

      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  };

  toggleSelectEmailList = display => {
    this.setState({ displaySelectEmailList: display });
  };

  hideEmailList = () => {
    this.toggleSelectEmailList(false);
  };

  handleEmailChange = e => {
    e.preventDefault();
    this.setState({ email: e.target.value });
  };

  handleEmailSelected = async email => {
    this.toggleSelectEmailList(false);
    await this.setState({ email });
    this.login();
  };

  handleSubmit = e => {
    e.preventDefault();
    this.login();
  };

  login = async () => {
    const { requestId, action } = this.props;
    const { email } = this.state;

    const formData = [
      `email=${encodeURIComponent(email)}`,
      `requestId=${encodeURIComponent(requestId)}`,
      `action=${action}`
    ];

    this.setState({ loading: true });

    try {
      const res = await request('/session/login', formData.join('&'));

      if (res.status >= 300 || res.status < 200) {
        this.setState({ loading: false, ...SERVER_ERROR });
        return;
      }

      const data = await res.json();

      if (data.action === 'success') {
        // Login is happening abroad
        document.location.href = data.redirectUri;
        return;
      }

      if (!data.error) {
        this.props.onUpdateSession({ ...data });
        return;
      }

      if (data.error === 401) {
        this.setState({ loading: false });
        this.props.onUpdateSession({
          requestId: data.requestId,
          action: data.action
        });
      } else {
        this.initRequest();
      }
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  };

  render() {
    const { loading, error, email, signupToken, displaySelectEmailList } = this.state;
    const { emails } = this.props;

    if (loading) {
      return <Loading />;
    }
    if (error.length > 0) {
      return <div className="boxed-container"><div className="margin-top-large">{error}</div></div>;
    }

    if (!displaySelectEmailList) {
      return (
        <EmailForm
          email={email}
          emails={emails}
          signupToken={signupToken}
          onChange={this.handleEmailChange}
          onBack={this.toggleSelectEmailList}
          handleSubmit={this.handleSubmit}
        />
      );
    } else {
      return <EmailList emails={emails} onSelect={this.handleEmailSelected} onSelectAnother={this.hideEmailList} />;
    }
  }
}

export default Email;
